import { useCallback, useContext } from 'react';
import { ChatActionType, type RepSearchResult } from '@trinity/chat';
import { ActiveChatSessionContext, SubmitActionContext } from '../context';
import { hasAwaitingRepSelectionPendingWorkflow } from '../utils/pending-form-workflow';

export function useRepSelectionAction(): (rep: Pick<RepSearchResult, 'id' | 'name'>) => void {
  const activeChatSession = useContext(ActiveChatSessionContext);
  const submitAction = useContext(SubmitActionContext);

  const hasPendingFormWorkflow = hasAwaitingRepSelectionPendingWorkflow(activeChatSession);

  return useCallback(
    (rep: Pick<RepSearchResult, 'id' | 'name'>) => {
      submitAction(
        {
          type: ChatActionType.SelectRepSubject,
          payload: {
            repId: rep.id,
            repName: rep.name,
          },
        },
        hasPendingFormWorkflow ? `Use ${rep.name} for my form.` : `Show me the summary for ${rep.name}.`
      );
    },
    [hasPendingFormWorkflow, submitAction]
  );
}
